import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import Material from '@primeng/themes/material';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { AppConfigService } from './core/config/app-config.service';
import { AuthService } from './core/services/auth.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { jwtInterceptor } from './core/interceptors/jwt.interceptor';
import { MessageService } from 'primeng/api';
import { APP_DIALOG_COMPONENT, GENERAL_CRUD_SERVICE } from 'sf-crud';
import { PDF_GATEWAY_SERVICE } from 'sf-pdfsign';
import { GeneralService } from './features/formularios/services/general.service';
import { WarningComponent } from './shared/components/warning/warning.component';
import { DialogService } from 'primeng/dynamicdialog';
import { DocumentService } from './features/formularios/services/document.service';

const MyPreset = {
  ...Material,
  semantic: {
    ...Material.semantic,
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
};

export function loadConfig(appConfig: AppConfigService) {
  return () => appConfig.load();
}

export function generateToken(authService: AuthService) {
  return () => authService.generateToken();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.generateToken();
    }),
    provideAppInitializer(() => {
      const appConfigService = inject(AppConfigService);
      return appConfigService.load();
    }),
    provideAnimations(),
    provideClientHydration(withEventReplay()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([jwtInterceptor])),
    providePrimeNG({
      ripple: true,
      inputStyle: 'outlined',
      theme: { preset: MyPreset, options: { darkModeSelector: '.app-dark' } },
    }),
    DialogService,
    MessageService,
    {
      provide: GENERAL_CRUD_SERVICE,
      useClass: GeneralService,
    },
    {
      provide: PDF_GATEWAY_SERVICE,
      useClass: DocumentService,
    },
    {
      provide: APP_DIALOG_COMPONENT,
      useValue: { key: 'create', component: WarningComponent },
      multi: true,
    },
  ],
};
